/** Styles for the sky package (weather in the HUD, forecast card, typhoon checklist). Injected once. */
const CSS = `

.sky-fc { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; margin: 0 0 8px; }
.sky-fc .day { display: flex; align-items: center; gap: 8px; padding: 7px 8px; border-radius: 10px; background: rgba(255,255,255,.05); border: 1px solid var(--line-soft); min-width: 0; }
.sky-fc .day.typhoon { background: rgba(224,83,61,.16); border-color: #e0533d; }
.sky-fc .ic { font-size: 26px; line-height: 1; }
.sky-fc .tx { min-width: 0; }
.sky-fc .tx b { display: block; font-size: 11px; color: var(--gold); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sky-fc .tx span { display: block; font-size: 12px; font-weight: 800; color: var(--cream); }
.sky-fc .tx small { display: block; font-size: 10.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #9fd0ff; font-variant-numeric: tabular-nums; }
.sky-fc .tx em { display: block; font-size: 10px; font-style: normal; color: var(--muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sky-fc .tip { grid-column: 1 / -1; font-size: 11.5px; color: var(--muted); margin: 0; }
.sky-alert { margin: 0 0 8px; padding: 8px 10px; border-radius: 10px; background: linear-gradient(180deg, #8a2417, #5e160d); border: 1px solid #ff8a6a; color: #ffeadf; font-weight: 800; font-size: 12.5px; line-height: 1.35; }

.sky-kit { list-style: none; margin: 0; padding: 0; display: grid; gap: 6px; }
.sky-kit li { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 10px; background: rgba(255,255,255,.05); border: 1px solid var(--line-soft); }
.sky-kit li.done { background: rgba(47,174,102,.14); border-color: rgba(47,174,102,.55); }
.sky-kit .ic { font-size: 24px; line-height: 1; }
.sky-kit .tx { flex: 1; min-width: 0; font-size: 12.5px; font-weight: 700; }
.sky-kit .tx small { display: block; margin-top: 2px; font-size: 11px; font-weight: 600; color: #9fd0ff; font-style: italic; }
.sky-kit .ok { color: #5ee08a; font-weight: 900; font-size: 12px; white-space: nowrap; }
.sky-kit .hint { color: var(--muted); font-size: 10.5px; max-width: 76px; text-align: right; }
.sky-kit-intro { margin: 0 0 8px; font-size: 12.5px; color: var(--muted); }
.sky-kit-bar { height: 8px; margin: 0 0 10px; border-radius: 4px; background: #120c08; border: 1px solid var(--line-soft); overflow: hidden; }
.sky-kit-bar i { display: block; height: 100%; background: linear-gradient(90deg, #2fae66, #8be0a8); transition: width .35s ease; }
`;

let done = false;
export function injectSkyStyles(): void {
  if (done || typeof document === 'undefined') return;
  done = true;
  const el = document.createElement('style');
  el.dataset.pkg = 'sky';
  el.textContent = CSS;
  document.head.appendChild(el);
}
